import React, { useState } from "react";
import overwriteWhite from "@assets/overwrite-white.svg";
import overwriteGreen from "@assets/overwrite-green.svg";
import copyWhite from "@assets/copy-white.svg";
import copyBlue from "@assets/copy-blue.svg";
import cancelWhite from "@assets/cross-white.svg";
import cancelRed from "@assets/cross-red.svg";

interface ConflictActionButtonProps {
  action: "cancel" | "copy" | "overwrite";
  isSelected: boolean;
  onSelect: () => void;
  disabled: boolean;
}

const ConflictActionButton: React.FC<ConflictActionButtonProps> = ({
  action,
  isSelected,
  onSelect,
  disabled,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const baseStyles = "p-2 rounded text-sm font-medium border";
  const colorStyles = {
    cancel: isSelected
      ? "bg-red-600 text-white border-red-600"
      : "text-red-600 border-red-600",
    copy: isSelected
      ? "bg-blue-600 text-white border-blue-600"
      : "text-blue-600 border-blue-600",
    overwrite: isSelected
      ? "bg-green-600 text-white border-green-600"
      : "text-green-600 border-green-600",
  };

  const imgs = {
    cancel: isSelected ? cancelWhite : cancelRed,
    overwrite: isSelected ? overwriteWhite : overwriteGreen,
    copy: isSelected ? copyWhite : copyBlue,
  };

  return (
    <div className="relative">
      <button
        type="button"
        disabled={disabled}
        onClick={onSelect}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`${baseStyles} ${colorStyles[action]} ${
          disabled && "opacity-70 cursor-not-allowed"
        }`}
      >
        <img src={imgs[action]} className="w-4" alt={action} />
      </button>
      {isHovered && (
        <div className="absolute top-[-30px] left-[-80%] bg-gray-800 text-white text-xs rounded px-2 py-1 z-10">
          {action.charAt(0).toUpperCase() + action.slice(1)}
        </div>
      )}
    </div>
  );
};

export default ConflictActionButton;
